<template>
  <div class="mc-linear-wizard">
    <McWizard
      compact
      :withNumber="withNumber"
      :activeKey="activeKey"
      :items="items"
      :isSingleStatus="isSingleStatus"
    />
  </div>
</template>

<script>
import McWizard from '@/components/McWizard'

export default {
  components: {
    McWizard,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    activeKey: {
      type: String,
      default: null,
    },
    withNumber: {
      type: Boolean,
      default: true,
    },
    isSingleStatus: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style src="./style.scss" lang="scss" scoped></style>
